<opac-dialog
  [open]="open()"
  [size]="'large'"
  [title]="title() | translate"
  (closed)="closeModal()"
>
  <div class="container">
    <div class="cover">
      <opac-record-cover [coverUrl]="selectedCoverUrl()" [isList]="true" [showIcon]="false"></opac-record-cover>
      <opac-button *ngIf="list()?.items?.length > 1" class="edit-cover" [ariaLabel]="'lists.coverSelect' | translate" [opacTooltip]="'lists.coverSelect' | translate" (click)="openCoverSelectionDialog()">
        <opac-icon icon="edit" slot="only-icon"></opac-icon>
      </opac-button>
    </div>

    <form id="list-edit-form" (submit)="saveList($event)">
      <opac-text-input
        #listNameInput
        [autofocus]="true"
        [invalid]="list()?.name?.length === 0"
        [name]="'name'"
        [required]="true"
        [ngModel]="list()?.name"
        (ngModelChange)="updateListName($event)"
      >
        {{ 'lists.name' | translate }}

        <span slot="error" *ngIf="list()?.name?.length === 0">
          {{ 'edit-list.errors.required' | translate }}
        </span>
      </opac-text-input>

      <opac-textarea
        #descriptionTextarea
        [counter]="true"
        [invalid]="descriptionError() !== null"
        [maxLength]="descriptionMaxLength()"
        [name]="'description'"
        [ngModel]="list()?.description"
        (ngModelChange)="updateListDescription($event)"
      >
        {{ 'lists.description' | translate }}

        <span slot="error" *ngIf="descriptionError() !== null">
          {{ descriptionError() | translate }}
        </span>
      </opac-textarea>

      <opac-checkbox *ngIf="canCreatePublicList()" [checked]="list()?.privateList === false" (change)="updateListPrivacy($event)">{{ 'listEdit.privacySelector.label' | translate }}</opac-checkbox>
    </form>
  </div>

  <div class="actions" slot="actions">
    <opac-button form="list-edit-form" actionType="submit">
      {{ 'general.save' | translate }}
    </opac-button>

    <opac-button [type]="'secondary'" (click)="closeModal()">
      {{ 'general.cancel' | translate }}
    </opac-button>
  </div>
</opac-dialog>

<app-cover-selection-dialog></app-cover-selection-dialog>

<opac-confirmation-dialog
  [acceptLabel]="'general.accept'"
  [cancelLabel]="'general.cancel'"
  [open]="openPrivateWarningDialog()"
  [title]="'user.lists.dialogs.privacyChange.title' | translate"
  (accept)="handlePrivacyWarningDialogResponse(true)"
  (cancel)="handlePrivacyWarningDialogResponse(false)"
>
  {{ 'user.lists.dialogs.privacyChange.body' | translate }}
</opac-confirmation-dialog>
